import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset scroll to top on route change (except when navigating to a hash).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
